module.exports = __webpack_public_path__ + "static/img/1_9_1.b0fe01a9.jpg";